import { EMPTY_LIST, EMPTY_OBJECT } from '../constants/common'
import { DESC_ORDER_SYMBOL } from '../constants/sort'

export function getDescSortParam(name) {
  return DESC_ORDER_SYMBOL.concat(name)
}

export function toOrderingList(ordering) {
  return Array.isArray(ordering) ? ordering : EMPTY_LIST
}

export function parseToOldApiOrdering(ordering) {
  if (ordering.length > 0) {
    return { ordering: ordering.join(',') }
  }

  return EMPTY_OBJECT
}
